import React from "react";
import ReactDOM from 'react-dom';
import StaffMember from "./staff/StaffMember";

export default () => {

    const people = document.querySelectorAll('[data-staff-json]');
    for (const person of people) {
        const data = JSON.parse(person.getAttribute('data-staff-json'));
        ReactDOM.render(<StaffMember person={data} />, person);
    }

}
